<template>
  <section>
    <div class="fileBoxStep1">
      <div class="fileBoxStep1-title">
        {{ obj.title }}
      </div>
      <div class="fileBoxStep1-date">
        2019-10-29 来源：河南省教育厅
      </div>
      <div class="fileBoxStep1-content">
        <com-table :data="obj.content" :configs="config" stripe border />
      </div>
    </div>
  </section>
</template>

<script>
import comTable from '@/components/comTable'
export default {
  name: 'ComStep1',
  components: { comTable },
  props: {
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    config: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang='scss' scoped>
.fileBoxStep1 {
  height: 100%;
  padding: 20px;
  &-title {
    height: 60px;
    font-size: 26px;
    text-align: center;
    margin-top: 20px;
    color: #333;
    font-weight: bold;
    font-family: "Microsoft YaHei";
  }
  &-date {
    text-align: center;
    color: #999;
    font-size: 14px;
    padding-bottom: 20px;
    font-family: "Microsoft YaHei";
  }
  &-content {
    line-height: 36px;
    @include fun-design(1);
    color: #333;
    font-size: 16px;
    font-family: "Microsoft YaHei";
  }
}
</style>
